<template>
  <section class="card-section">
    <div v-if="isHeaderVisible" class="card-section__row">
      <h3 class="card-section__title" :class="{ 'card-section__title--bold': isActionVisible }">
        {{ title }}
      </h3>
      <button v-if="isActionVisible" @click="actionHandler">
        {{ actionLabel }}
        <HdIcon :src="icons.plusCircle" height="24" width="24" />
      </button>
    </div>
    <slot />
  </section>
</template>

<script>
import { HdIcon } from 'homeday-blocks';
import { plusCircle } from 'homeday-assets';

export default {
  name: 'CardSection',
  components: { HdIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    actionLabel: {
      type: String,
      default: '',
    },
    actionEvent: {
      type: String,
      default: '',
    },
  },
  computed: {
    isHeaderVisible() {
      return !!this.title;
    },
    isActionVisible() {
      return !!this.actionLabel;
    },
    icons() {
      return {
        plusCircle,
      };
    },
  },
  methods: {
    actionHandler() {
      this.$emit('actionCall', this.actionEvent);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-section {
  display: flex;
  flex-direction: column;
  gap: $sp-m + $sp-s;
  max-width: 600px;

  @include for('tablet') {
    width: 100%;
    align-self: center;
  }

  @include for('desktop-wide') {
    width: unset;
    align-self: unset;
  }

  &__row,
  &__row > button {
    align-items: center;
    display: flex;
    gap: $sp-s;
    justify-content: space-between;
  }

  &__row > button {
    @include fontGroup(100, 600);
    background-color: transparent;
    border: none;
    color: getShade($secondary-color, 120);
    cursor: pointer;
    padding: 0;

    ::v-deep path {
      fill: getShade($secondary-color, 120);
    }
  }

  &__title {
    @include fontGroup(100, 900);

    &--bold {
      @include fontGroup(200, 900);
    }
  }
}
</style>
